export const MAINTENANCE_PACKAGE_VISIBLE_FIELDS = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'maintenancePackage.Name' },
    { key: 'details', label: 'maintenancePackage.Details' },
    { key: 'isActive', label: 'maintenancePackage.IsActive' },
    { key: 'createdAt', label: 'maintenancePackage.CreatedAt' },
];

export const LOCAL_STORAGE_MAINTENANCE_PACKAGE_ROWS =
    'maintenance-packages-row';

export const LOCAL_STORAGE_MAINTENANCE_PACKAGE_FILTERS =
    'maintenance-packages-advanced-filters';
